import { gql } from '@apollo/client';

export const GET_FORM_VERSION = gql`
  query GetFormVersion($id: ID!, $companyId: String!) {
    formVersion(id: $id, companyId: $companyId) {
      id
      templateId
      name
      welcomePageRichText
      pages
      isAnonymous
      isInfinitelyRespondable
      isPasscodeRequired
    }
  }
`;

export const GET_FORM_VERSION_NO_AUTH = gql`
query GetFormVersionNoAuth($id: ID!, $companyId: String!) {
    formVersionNoAuth(id: $id, companyId: $companyId) {
      id
      templateId
      name
      welcomePageRichText
      pages
      isAnonymous
      isInfinitelyRespondable
      isPasscodeRequired
    }
  }
`;

export const GET_FORM_VERSION_BY_ID_AND_FRIENDLY_COMPANY_ID_NO_AUTH = gql`
  query GetFormVersionByIdAndFriendlyCompanyIdNoAuth(
    $id: ID!
    $friendlyCompanyId: String!
  ) {
    formVersionByIdAndFriendlyCompanyIdNoAuth(
      id: $id
      friendlyCompanyId: $friendlyCompanyId
    ) {
      id
      templateId
      name
      welcomePageRichText
      pages
      isAnonymous
      isInfinitelyRespondable
      isPasscodeRequired
    }
  }
`;

export const CREATE_FORM_VERSION = gql`
  mutation CreateFormVersion($input: FormVersionInput!) {
    createFormVersion(input: $input) {
      id
      templateId
      name
      welcomePageRichText
      pages
      isAnonymous
      isInfinitelyRespondable
      isPasscodeRequired
      ownerId
      companyId
      createdAt
      updatedAt
    }
  }
`;

export const GET_ALL_FORM_VERSIONS_FOR_TEMPLATE = gql`
  query GetAllFormVersionsForTemplate($templateId: ID!) {
    getFormVersionsByTemplateId(templateId: $templateId) {
      id
      templateId
      name
      welcomePageRichText
      pages
      isAnonymous
      isInfinitelyRespondable
      isPasscodeRequired
      ownerId
      companyId
      createdAt
      updatedAt
    }
  }
`;

export const GET_ALL_FORM_VERSIONS_FOR_CURRENT_USER = gql`
  query GetAllFormVersionsForCurrentUser {
    formVersions {
      id
      templateId
      name
      welcomePageRichText
      pages
      isAnonymous
      isInfinitelyRespondable
      isPasscodeRequired
      ownerId
      companyId
      createdAt
      updatedAt
    }
  }
`;

export const GET_FORM_VERSIONS_BY_IDS = gql`
  query GetFormVersionsByIds($ids: [ID!]!) {
    formVersionsByIds(ids: $ids) {
      id
      templateId
      name
      welcomePageRichText
      pages
      isAnonymous
      isInfinitelyRespondable
      isPasscodeRequired
      ownerId
      companyId
      createdAt
      updatedAt
    }
  }
`;

export const GET_FORM_VERSIONS_COUNT = gql`
  query GetFormVersionsCount {
    formVersionsCount {
      count
    }
  }
`;
